import { IEventSubscription } from "../event-subscription";

export abstract class SocketServiceBase {
	protected host:string;
	protected path:string;
	protected subs:IEventSubscription[] = [];
	protected _isConnected:boolean = false;

	public constructor(host:string, path:string){
		this.host = host;
		this.path = path;
	}


	on(event: string, handler: Function, ref?: any): void {
		this.addSub({event, handler, ref, once: false});
	}
	once(event: string, handler: Function, ref?: any): void {
		this.addSub({event, handler, ref, once: true});
	}
	off(event: string, handler: Function, ref?: any): void {
		this.removeSub({event, handler, ref, once: false});
	}
	offAll(ref: any): void {
		for (let i = this.subs.length-1; i >= 0; i--){
			let s = this.subs[i];
			if (s.ref == ref){
				this.subs.splice(i, 1);
			}
		}
	}

	protected addSub(sub:IEventSubscription){
		this.subs.push(sub);
	}

	protected removeSub(sub:IEventSubscription){
		for (let i = this.subs.length-1; i >= 0; i--){
			let s = this.subs[i];
			if (s.event == sub.event && s.handler == sub.handler && s.ref == sub.ref){
				this.subs.splice(i, 1);
			}
		}
	}

	protected triggerEvent(event:string, ...data:any){
		for (let i = this.subs.length - 1; i >= 0; i--){
			let sub = this.subs[i];
			if (!sub) return;
			if (sub.event != event) continue;
			if (sub.once){
				this.subs.splice(i, 1);
			}
			sub.handler(...data);
		}
	}

	broadcastToTabs(...data:any[]){
		return;
	}

	abstract emit(event:string, ...data:any):Promise<any>;
	abstract connect():Promise<void>;
	abstract disconnect():Promise<void>;
	abstract getId():string;
	abstract setAccessToken(token:string):void;

	public isConnected():boolean {
		return this._isConnected;
	}
}